import { RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { type OrderDraftConstructorData } from '../../../entities/OrderDraft'
import { type IOrderDraftRepository } from '../../interfaces/IOrderDraftRepository'

export class GetOrderDraftUseCase {
  constructor(
    private readonly deps: {
      orderDraftRepository: IOrderDraftRepository
      initializeOrderDraftOrgCategoriesUseCase: (params: {
        userId: number
        userPrimaryCategoryId: Nullable<number>
        userSecondaryCategoryId: Nullable<number>
      }) => Promise<Nullable<number>>
    }
  ) {}

  execute = async ({
    userId,
    userPrimaryCategoryId,
    userSecondaryCategoryId,
  }: {
    userId: number
    userPrimaryCategoryId: Nullable<number>
    userSecondaryCategoryId: Nullable<number>
  }): Promise<OrderDraftConstructorData> => {
    try {
      return await this.deps.orderDraftRepository.getOrderDraft()
    } catch (err) {
      if (err instanceof RepoError && err.status === 404) {
        const secondaryCategoryId =
          await this.deps.initializeOrderDraftOrgCategoriesUseCase({
            userId,
            userPrimaryCategoryId,
            userSecondaryCategoryId,
          })
        return await this.deps.orderDraftRepository.createOrderDraft(
          secondaryCategoryId ?? undefined
        )
      }
      throw err
    }
  }
}
